import { executeCode } from '@helpers'
import { FIELD_BIND_TYPE_ENUM } from '@constants'
import { MapPointGroup, ObjectDataRecord } from '@types'

/**
 * Вычисляет цвет точки для группы и записи данных.
 *
 * Поддерживаемые режимы:
 * - FIELD_BIND_TYPE_ENUM.JS — value содержит JavaScript-код, исполняемый через executeCode
 * - FIELD_BIND_TYPE_ENUM.STATIC — value содержит статическое строковое значение цвета
 */
export const getPointColor = (
  group: MapPointGroup,
  record: ObjectDataRecord
): string | undefined => {
  const pointStyle = group.pointStyle

  if (!pointStyle?.color) {
    return undefined
  }

  const { bindType, value } = pointStyle.color

  switch (bindType) {
    case FIELD_BIND_TYPE_ENUM.JS: {
      const result = executeCode(value, {
        srcObj: record,
      })

      if (result === false || result === null || result === undefined) {
        return undefined
      }

      const color = String(result).trim()

      return color.length ? color : undefined
    }

    case FIELD_BIND_TYPE_ENUM.STATIC: {
      const color = value.trim()

      return color.length ? color : undefined
    }

    default:
      return undefined
  }
}
